import { Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { UserService } from '../../shared/user.service';

@Injectable({
  providedIn: 'root'
})
export class CurrentUserProfileResolver implements Resolve<any>{
  constructor(
    private userService: UserService)
  {}

  resolve(): Observable<any> | Promise<any> | any {
    return this.userService.getCurrUserProfileInfo().pipe(
      tap((data) => {
        return data;
      }));
  }
}
